import {Component, Input, OnDestroy, OnInit} from '@angular/core';

import { LabOrder } from '../../shared/data/lab-order';
import { LabOrderBusinessService } from '../../shared/lab-order-business.service';
import { ReferenceListItem } from '../../shared/data/reference-list-item';
import { LabOrderReferenceApiService, REF_LIST } from '../../shared/lab-order-reference-api.service';
import {UtilsService} from '../../shared/utils.service';
import {SubscriptionsContainer} from '../../shared/subscriptions-container';

@Component({
  selector: 'app-prescription',
  templateUrl: './prescription.component.html',
  styleUrls: ['./prescription.component.css']
})
export class PrescriptionComponent implements OnInit, OnDestroy {

  @Input() labOrder: LabOrder;

  thicknessCodes: ReferenceListItem[];
  subs = new SubscriptionsContainer();

  constructor(
    private labOrderBusinessService: LabOrderBusinessService
  ) { }

  ngOnInit(): void {

    // get the reference lists to populate the drop-downs in the bevel section.
    this.subs.add = this.labOrderBusinessService.getReferenceListsByNames([REF_LIST.THICKNESS_TYPE_CODES])
      .subscribe(
        (data) => {
          this.thicknessCodes = this.labOrderBusinessService.prettifyRefList(data[0],
            this.labOrderBusinessService.getNewEmptyReferenceListItem());
        },
        (error) => {
          this.thicknessCodes = null;
          console.log('Did not retrieve prescription section referencelists');
        }
      );
  }
  ngOnDestroy(): void {
    console.log(' Prescription Component - ngOnDestroy ' );
    this.subs.dispose();
  }

  // Sets the value of the html field back to the object model after applying the RxPower formatter.
  public updateSphereR(event) {
    this.labOrder.prescription.sphereRight = UtilsService.formatRxPower(event.target.value);
  }

  // Sets the value of the html field back to the object model after applying the RxPower formatter.
  public updateSphereL(event) {
    this.labOrder.prescription.sphereLeft = UtilsService.formatRxPower(event.target.value);
  }

  // Sets the value of the html field back to the object model after applying the RxPower formatter.
  public updateCylinderR(event) {
    this.labOrder.prescription.cylinderRight = UtilsService.formatRxPower(event.target.value);
  }

  // Sets the value of the html field back to the object model after applying the RxPower formatter.
  public updateCylinderL(event) {
    this.labOrder.prescription.cylinderLeft = UtilsService.formatRxPower(event.target.value);
  }

  // Sets the value of the html field back to the object model.
  // This is needed because we can't use a formatter on a field with two-way binding.
  public updatePDBinDist(event) {
    this.labOrder.prescription.pdBinocularDistant = event.target.value;
  }

  // Sets the value of the html field back to the object model.
  // This is needed because we can't use a formatter on a field with two-way binding.
  public updatePDBinNear(event) {
    this.labOrder.prescription.pdBinocularNear = event.target.value;
  }

  // Sets the value of the html field back to the object model.
  // This is needed because we can't use a formatter on a field with two-way binding.
  public updatePDMonoDistantLeft(event) {
    this.labOrder.prescription.pdMonocularDistantLeft = event.target.value;
  }

  // Sets the value of the html field back to the object model.
  // This is needed because we can't use a formatter on a field with two-way binding.
  public updatePDMonoDistantRight(event) {
    this.labOrder.prescription.pdMonocularDistantRight = event.target.value;
  }

  // Sets the value of the html field back to the object model.
  // This is needed because we can't use a formatter on a field with two-way binding.
  public updatePDMonoNearLeft(event) {
    this.labOrder.prescription.pdMonocularNearLeft = event.target.value;
  }

  // Sets the value of the html field back to the object model.
  // This is needed because we can't use a formatter on a field with two-way binding.
  public updatePDMonoNearRight(event) {
    this.labOrder.prescription.pdMonocularNearRight = event.target.value;
  }

  // When switching to the given targetMeasurementType, clear out the values of the opposite measurement type.
  // eg. when new measurement type is MONOCULAR, clear the Binocular values.
  public switchAndClearPDMeasurements(targetMeasurementType) {
    if (targetMeasurementType === 'MONOCULAR') {
      this.labOrder.prescription.pdBinocularNear = null;
      this.labOrder.prescription.pdBinocularDistant = null;

    } else {
      // targetMeasurementType === BINOCULAR
      this.labOrder.prescription.pdMonocularNearLeft = null;
      this.labOrder.prescription.pdMonocularNearRight = null;
      this.labOrder.prescription.pdMonocularDistantLeft = null;
      this.labOrder.prescription.pdMonocularDistantRight = null;
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/modify-order/prescription/prescription.component.ts